import { useRouter } from "next/router";
import BrandSwiper from "../global/swiper/BrandSwiper";

const Brands = ({ data, t, isNew }) => {
  const { locale } = useRouter();
  return data?.value?.length ? (
    <section className="py-4">
      <p className="text-lg font-[500] text-center sm:text-3xl">
        {data[`title-${locale}`] || t("Our Brands")}
      </p>
      <div className="relative w-11/12 mx-auto my-4 sm:my-8">
        <BrandSwiper data={data} isNew={isNew} />
      </div>
    </section>
  ) : null;
};

export default Brands;
